import Compressor from 'compressorjs';
import { logger } from 'monitor';

export const compressBalePhoto = (photo: File) => {
  return new Promise((resolve: (value: File) => void) => {
    new Compressor(photo, {
      error: (err) => logger.error(err.message),
      maxHeight: 4000,
      maxWidth: 4000,
      quality: 0.9,
      retainExif: true,
      success: resolve,
    });
  });
};
